const NS = 'SiteSubheaderTopicWidget';
const CLS = 'siteSubheaderTopicWidget';

import { overlay } from '../../../../global/js/wlc/overlay';

export class SiteSubheaderTopicWidget {
	constructor(element) {
		this.element = element;
		this.$element = $(element);
		this.$tplHeader = $('.tpl-header');
		this.$progressBar = this.$element.children('.progressBarWidget');
		this.overlay = overlay;

		// Notepad toggle button
		this.$notepadToggleButton = this.$element.find(`#${CLS}NotepadToggle`);
		this.$notepad = $('#notepad');
		this.$notepadToggleButton.on('click', () => {
			if(this.$notepadToggleButton.hasClass('open')) {
                this.$notepadToggleButton.removeClass('open');
                this.$notepad.removeClass('open');
			}
			else {
                this.$notepadToggleButton.addClass( 'open' );
                this.$notepad.addClass('open');
            }
		});

		// Topic dropdown
		this.$topicDropdown = this.$element.find(`.siteSubheaderTopicDropdownWidget`);
		$(document.body).append(this.$topicDropdown);
		this.setSubheaderTopicDropdownPosition();

		// Index button
		this.$indexButton = this.$element.find(`.${CLS}-btn--index`);
		this.$indexButton.on('click', () => {
			this.$topicDropdown.addClass('active');
			this.setSubheaderTopicDropdownHeight();
			this.overlay.create(() => {
				this.$topicDropdown.removeClass('active');
			});
		});

		// Percentage update
		this.$element.on('siteSubheaderTopicWidget.percentage.update', (event, params) => {
			this.$progressBar.trigger('progressBarWidget.update', {
				percentage: params.percentage
			});
		});


		// Resizes the dropdownHeight when needed
		$(window).resize(_.debounce(() => {
			this.setSubheaderTopicDropdownPosition();
			if(this.$topicDropdown.hasClass('active')) {
				this.setSubheaderTopicDropdownHeight();
			}
		}, 250));
	}

	setSubheaderTopicDropdownHeight() {
		let offsetTop = Math.floor(this.$topicDropdown.offset().top);
		this.$topicDropdown.css({
			maxHeight: `calc(100vh - ${offsetTop}px)`
		});
	}

	setSubheaderTopicDropdownPosition() {
		this.$topicDropdown.css({
			top: this.$tplHeader.offset().top + this.$tplHeader.height()
		});
	}
}
